  <div class="w-full flex justify-between">
<h2 mat-dialog-title class="flex justify-between items-center">
  <span>Histórico de Importações</span>
</h2>
  <button class="btn-icon pr-5 pt-5" (click)="close()">
    <mat-icon>close</mat-icon>
  </button>
  </div>

@if (loading) {
  <mat-progress-bar mode="indeterminate" />
}

<mat-dialog-content class="!max-h-[70vh]">
  @if (!loading && itemsList.length === 0) {
    <div class="text-center text-gray-400 py-10 text-sm">Nenhuma importação encontrada.</div>
  }

  @if (itemsList.length > 0) {
    <table mat-table [dataSource]="itemsList" class="mat-elevation-z2 w-full">

      <ng-container matColumnDef="codigoTg">
        <th mat-header-cell *matHeaderCellDef>Código TG</th>
        <td mat-cell *matCellDef="let element">{{ element.codigoTg ?? '-' }}</td>
      </ng-container>

      <ng-container matColumnDef="dataImportacao">
        <th mat-header-cell *matHeaderCellDef>Data</th>
        <td mat-cell *matCellDef="let element">{{ element.dataImport }} {{ element.horaImport }}</td>
      </ng-container>

      <ng-container matColumnDef="nomeResponsavel">
        <th mat-header-cell *matHeaderCellDef>Responsável</th>
        <td mat-cell *matCellDef="let element">{{ element.nome }}</td>
      </ng-container>

      <ng-container matColumnDef="totalCompletos">
        <th mat-header-cell *matHeaderCellDef class="text-center">Completos</th>
        <td mat-cell *matCellDef="let element" class="text-center">
          <span class="text-green-600 font-semibold">{{ element.totalCompletos }}</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="totalIncompletos">
        <th mat-header-cell *matHeaderCellDef class="text-center">Incompletos</th>
        <td mat-cell *matCellDef="let element" class="text-center">
          <span class="text-yellow-600 font-semibold">{{ element.totalIncompletos }}</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="totalIgnorados">
        <th mat-header-cell *matHeaderCellDef class="text-center">Ignorados</th>
        <td mat-cell *matCellDef="let element" class="text-center">
          <span class="text-red-500 font-semibold">{{ element.totalIgnorados }}</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="acoes">
        <th mat-header-cell *matHeaderCellDef class="text-center">Ações</th>
        <td mat-cell *matCellDef="let element" class="text-center">
          <div class="flex justify-center items-center gap-2">
            @if (element.temLog) {
              @if (downloadingLog === element.importPassageiroId) {
                <mat-spinner diameter="20"></mat-spinner>
              } @else {
                <button
                  class="btn-icon"
                  matTooltip="Baixar log"
                  (click)="downloadLog(element.importPassageiroId)"
                >
                  <mat-icon>description</mat-icon>
                </button>
              }
            }
            @if (element.temExcel) {
              @if (downloadingExcel === element.importPassageiroId) {
                <mat-spinner diameter="20"></mat-spinner>
              } @else {
                <button
                  class="btn-icon"
                  matTooltip="Baixar planilha original"
                  (click)="downloadExcel(element.importPassageiroId)"
                >
                  <mat-icon>table_view</mat-icon>
                </button>
              }
            }
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>

    <mat-paginator
      [length]="numberRows"
      [pageSize]="rows"
      [pageIndex]="page - 1"
      [pageSizeOptions]="[5, 10, 20]"
      (page)="onPageEvent($event)"
    />
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-flat-button class="btn-tg" (click)="close()">Fechar</button>
</mat-dialog-actions>
